var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('nav-bar'),_c('aside-menu',{attrs:{"menu":_vm.menu}}),_c('div',{staticClass:"my-body"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }